import {
    AccountTypeClassGroup,
    getPredefinedGroupLabel,
    groupAccountTypesByClass,
} from "@common/constants/domains/accounting/accountGroups";
import { AccountType } from "@common/constants/domains/accounting/accounts";
import { getAvailableAccountTypes } from "@common/constants/domains/accounting/accountTypeHelpers";

// Report-leaf folding must not collapse editable exact types.
export const EDITOR_TYPE_CLASS_GROUPS: AccountTypeClassGroup[] =
    groupAccountTypesByClass(getAvailableAccountTypes());

export const EDITOR_TYPE_OPTIONS: AccountType[] =
    EDITOR_TYPE_CLASS_GROUPS.flatMap((group) => group.types);

export const toTypePickerSections = (groups: AccountTypeClassGroup[]) =>
    groups.map((group) => ({
        key: group.accountClass,
        title: group.accountClass,
        items: group.types.map((type) => ({
            value: type,
            label: getPredefinedGroupLabel(type),
        })),
    }));
